module.exports = __webpack_public_path__ + "img/799.76c5ef66.png";